<form [formGroup]="redefinirSenhaForm" (submit)="redefinirSenha()" class="form">
  <h2>Concluir redefinição de senha</h2>
  <p>Digite sua nova senha</p>
  <div class="row my-4">
    <div class="col">
      <label>Senha:</label>
      <input formControlName="senha" class="input form-control" type="password" placeholder="********">
    </div>
    <div class="message-error"
      *ngIf="redefinirSenhaForm.get('senha')?.errors?.required && redefinirSenhaForm.get('senha')?.dirty">
      Este campo é obrigatório.
    </div>
    <div class="message-error"
      *ngIf="redefinirSenhaForm.get('senha')?.errors?.pattern && redefinirSenhaForm.get('senha')?.dirty">
      Sua senha deve ter no mínimo 8 caracteres, sendo letras minusculas, maiúsculas, números e caracteres especiais.
    </div>
  </div>
  <div class="row my-4">
    <div class="col">
      <label>
        Confirmar senha:
      </label>
      <input formControlName="confirmarSenha" class="input form-control" type="password" placeholder="********">
    </div>
    <div class="message-error" *ngIf="redefinirSenhaForm.get('confirmarSenha')?.errors?.required &&
      redefinirSenhaForm.get('confirmarSenha')?.dirty">
      Este campo é obrigatório.
    </div>
    <div class="message-error" *ngIf="redefinirSenhaForm.hasError('senhasDiferentes') &&
      redefinirSenhaForm.get('senha')?.dirty && redefinirSenhaForm.get('confirmarSenha')?.dirty">
      As senhas não conferem!
    </div>
  </div>
  <div class="row my-5">
    <div class="col">
      <div>
        <button class="form-button button-primary" [disabled]="!redefinirSenhaForm.valid">Redefinir</button>
      </div>
    </div>
  </div>
</form>